<script setup lang="ts">
import type { PhxsgSlideProps as PhxsgCoreSlideProps } from '@sg-core/src/View/Components/Organisms/Slider';

import { PhxsgSlide } from '../Slider';

defineProps<PhxsgCoreSlideProps>();

/**
 * Define the component name to be 'SwiperSlide' so that
 * swiper detects the direct children as slides.
 */
defineOptions({
  name: 'SwiperSlide',
});
</script>

<template>
  <PhxsgSlide v-bind="$props">
    <div class="phxsg-card-slider__slide-wrapper">
      <slot />
    </div>
  </PhxsgSlide>
</template>
